export default "__VITE_ASSET__DsNM_8Yu__"